@if (props) {
  <mat-form-field>
    <mat-label>{{ props.label }}</mat-label>
    @switch (type) {
      @case ('number') {
        <input
          matInput
          #numberInput
          [id]="id"
          [name]="field.name"
          type="number"
          [readonly]="props.readonly"
          [required]="props.required"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [tabIndex]="props.tabindex"
          [placeholder]="props.placeholder"
          [errorStateMatcher]="matcher"
          (keypress)="preventNonNumericalInput($event)"
          (blur)="preventExceedingAllowedRange(numberInput.value)"
          (wheel)="$event.preventDefault()"
        />
      }
      @default {
        <input
          matInput
          [id]="id"
          [name]="field.name"
          [type]="type || 'text'"
          [readonly]="props.readonly"
          [required]="props.required"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [tabIndex]="props.tabindex"
          [placeholder]="props.placeholder"
          [errorStateMatcher]="matcher"
        />
      }
    }
    <mat-error>
      <formly-validation-message [field]="field"></formly-validation-message>
    </mat-error>
    @if (props['prefixText']) {
      <span matTextPrefix>{{ props['prefixText'] }}</span>
    }
    @if (props['suffixText']) {
      <span matTextSuffix>{{ props['suffixText'] }}</span>
    }
  </mat-form-field>
}
